import apiClient from "./apiClient";

// invoices
export const getInvoiceReport = (
  noLimit = true, 
  invoiceDateStart = "", 
  invoiceDateEnd = "",
  dueDateStart = "",
  dueDateEnd = "",
  petOwnerId = "",
  historyEntryUserId = "",
  procedureId = ""
) => apiClient
  .get("/reports/invoice", { params: { noLimit, invoiceDateStart, invoiceDateEnd, dueDateStart, dueDateEnd, petOwnerId, historyEntryUserId, procedureId } })
  .then(res => res);